import { Card, CardContent, Grid, Typography } from '@mui/material'
import React from 'react'

const HowToStudyScreen = () => {
  return (
    <Grid
      container
      direction="column"
      className="container"
      spacing="2"
      style={{ width: '100%', margin: '0' }}
    >
      <Grid item style={{ alignSelf: 'center' }}>
        <Typography
          component="h1"
          variant="h4"
          style={{
            textTransform: 'uppercase',
            fontWeight: '600',
            margin: 'auto',
            textAlign: 'center',
          }}
        >
          Hướng dẫn cách học
        </Typography>
      </Grid>

      <Grid item style={{ maxWidth: '80%', margin: 'auto' }}>
        <Card>
          <CardContent>
            <Grid container spacing="2">
              <Grid item style={{ minWidth: '100%' }}>
                <Typography variant="body1">
                  <strong>Bước 1:</strong>&nbsp;Điền đầy đủ thông tin về học
                  sinh ở phần profile.
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="body1">
                  <strong>Bước 2:</strong>&nbsp;Vào mục “Tìm một giáo viên” để
                  chọn một giáo viên.
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="body1">
                  <strong>Bước 3:</strong>&nbsp;Chọn kiểu bài học mà bạn muốn
                  học, tiến hành thanh toán bằng thẻ ATM hoặc bằng tài khoản Momo.
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="body1">
                  <strong>Bước 4:</strong>&nbsp;Kết nối với giáo viên bằng Skype
                  ID và số điện thoại, online đúng giờ trên Skype để học bài học
                  bạn đã đặt với giáo viên.
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="body1">
                  <strong>Bước 5 (tùy ý):</strong>&nbsp;Nếu giáo viên không online đúng giờ để dạy hoặc bạn có bất cứ khiếu nại gì, vui lòng liên hệ với chúng tôi hoặc bấm vào nút "Gửi khiếu nại" trong phần thông tin của bài học.
                  <br />Nếu bạn cảm thấy hài lòng về bài học, vui lòng xác nhận bài học thành công hoặc gửi một lời nhận xét về giáo viên.
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant='body1'>
                  <strong>Chú ý:</strong>&nbsp;Sau thời gian <strong>7 ngày</strong>, nếu người học không gửi khiếu nại về bài học hoặc xác nhận bài học đã hoàn thành, YouSpeak sẽ tự động chuyển trạng thái của bài học thành "Bài học đã thành công".
                </Typography>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  )
}

export default HowToStudyScreen
